var _require = require('prettier/standalone'),
    _require$doc$builders = _require.doc.builders,
    concat = _require$doc$builders.concat,
    group = _require$doc$builders.group,
    indent = _require$doc$builders.indent,
    join = _require$doc$builders.join,
    line = _require$doc$builders.line,
    softline = _require$doc$builders.softline;

var ParameterList = {
  print: function print(_ref) {
    var node = _ref.node,
        path = _ref.path,
        _print = _ref.print;

    // don't insert softlines when there are no parameters
    if (node.parameters.length === 0) {
      return '';
    }

    return group(concat([indent(concat([softline, join(concat([',', line]), path.map(_print, 'parameters'))])), softline]));
  }
};
module.exports = ParameterList;